import Vue from 'vue'
import VueRouter from 'vue-router'

//前台页
const index = () => import('@/view/index')
const home = () => import('@/view/home')
const join = () => import('@/view/join')
const industrial = () => import('@/view/industrial')
const news = () => import('@/view/news')
const news_detail = () => import('@/view/news_detail')
const duty_detail = () => import('@/view/duty_detail')
const company_detail = () => import('@/view/company_detail')
const company = () => import('@/view/company')
const loading = () => import('@/view/loading')
const creativePlant = () => import('@/view/plate/creativePlant')
const exhibitPlant = () => import('@/view/plate/exhibitPlant')
const exhibitPlant_detail = () => import('@/view/plate/exhibitPlant_detail')    //展览展示
const printingPlant = () => import('@/view/plate/printingPlant')
const artPlant = () => import('@/view/plate/artPlant')
const sciencePlant = () => import('@/view/plate/sciencePlant')


//管理端
const admin = () => import('@/components/index/index')
const adminHome = () => import('@/components/index/home')
const account = () => import('@/components/index/account')
const login = () => import('@/components/index/login')
const bannerList = () => import('@/components/bannerList')
const bannerUp = () => import('@/components/bannerUp')
const newsList = () => import('@/components/newsList')
const newsUp = () => import('@/components/newsUp')
const newsDetail = () => import('@/components/newsDetail')
const worksList = () => import('@/components/worksList')
const worksUp = () => import('@/components/worksUp')
const dutyList = () => import('@/components/dutyList')
const dutyUp = () => import('@/components/dutyUp')
const jobsList = () => import('@/components/jobsList')
const jobsUp = () => import('@/components/jobsUp')

const structure = () => import('@/components/group/structure')
const structureUp = () => import('@/components/group/structureUp')
const construction = () => import('@/components/group/construction')
const constructionUp = () => import('@/components/group/constructionUp')
const management = () => import('@/components/group/management')
const managementUp = () => import('@/components/group/managementUp')


const creative = () => import('@/components/depart/creative')    //创意中心
const creativeUp = () => import('@/components/depart/creativeUp')
const exhibit = () => import('@/components/depart/exhibit')    //展览展示
const exhibitUp = () => import('@/components/depart/exhibitUp')

const roleList = () => import('@/components/index/roleList')//系统设置


Vue.use(VueRouter);
//添加以下代码
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
        {
            path:'/',
            name:'home',
            component: home,
            label:"首页",
            children:[
                {
                    path:'/',
                    name:"index",
                    component:index,
                    label:"首页"
                },
                {
                    path:"join/:id?",
                    name:"join",
                    component:join,
                    label:"加入我们"
                },
                {
                    path:"industrial",
                    name:"industrial",
                    component:industrial,
                    label:"产业基地"
                },
                {
                    path:"news",
                    name:"news",
                    component:news,
                    label:"新闻列表"
                },
                {
                    path:"news_detail/:id",
                    name:"news_detail",
                    component:news_detail,
                    label:"新闻详情"
                },
                {
                    path:"duty_detail/:id",
                    name:"duty_detail",
                    component:duty_detail,
                    label:"责任与信任详情"
                },
                {
                    path:"company/:id?",
                    name:"company",
                    component:company,
                    label:"集团简介"
                },
                {
                    path:"company_detail/:id",
                    name:"company_detail",
                    component:company_detail,
                    label:"党建活动详情"
                },
                {
                    path:"loading",
                    name:"loading",
                    component:loading,
                    label:"敬请期待"
                },
                {
                    path:"creativePlant",
                    name:"creativePlant",
                    component:creativePlant,
                    label:"创意中心"
                },
                {
                    path:"exhibitPlant",
                    name:"exhibitPlant",
                    component:exhibitPlant,
                    label:"展览展示"
                },
                {
                    path:"exhibitPlant_detail/:id",
                    name:"exhibitPlant_detail",
                    component:exhibitPlant_detail,
                    label:"展览展示详情"
                },

                {
                    path:"printingPlant",
                    name:"printingPlant",
                    component:printingPlant,
                    label:"博雅彩印"
                },
                {
                    path:"artPlant",
                    name:"artPlant",
                    component:artPlant,
                    label:"博雅艺品"
                },
                {
                    path:"sciencePlant",
                    name:"sciencePlant",
                    component:sciencePlant,
                    label:"博雅科技"
                },

            ]
        },
       //管理端
        {
            path: '/login',
            name: 'login',
            component: login,
            label: "登录"
        },
        {
            path: "/admin",
            name:'admin',
            component: admin,
            label:"管理端",
            redirect:'/bannerList',
            children: [
                {
                    path: "/adminHome",
                    name: "adminHome",
                    component: adminHome,
                    meta: {title: '首页', link: '/adminHome', type: true},
                },
                {
                    path: "/account",
                    name: "account",
                    component: account,
                    meta: [
                        {title: '系统设置', link: "", type: true},
                        {title: '修改密码', link: "/account", type: true}
                    ],
                },
                {
                    path: "/bannerList",
                    name: "bannerList",
                    component: bannerList,
                    meta: [
                        {title: '轮播图管理', link: "", type: true},
                        {title: '轮播图列表', link: "/bannerList", type: true}
                    ],
                },
                {
                    path: "/bannerUp",
                    name: "bannerUp",
                    component: bannerUp,
                    meta: [
                        {title: '轮播图管理', link: "", type: true},
                        {title: '轮播图列表', link: "/bannerUp", type: true}
                    ],
                },
                {
                    path: "/newsList",
                    name: "newsList",
                    component: newsList,
                    meta: [
                        {title: '新闻中心', link: "", type: true},
                        {title: '新闻列表', link: "/newsList", type: true}
                    ],
                },
                {
                    path: "/newsDetail/:id",
                    name: "newsDetail",
                    component: newsDetail,
                    meta: [
                        {title: '新闻中心', link: "", type: true},
                        {title: '新闻列表', link: "/newsList", type: true},
                        {title: '新闻详情', link: "/newsDetail", type: true},
                    ],
                },
                {
                    path: "/newsUp/:id?",
                    name: "newsUp",
                    component: newsUp,
                    meta: [
                        {title: '新闻中心', link: "", type: true},
                        {title: '新闻上传', link: "/newsUp", type: true}
                    ],
                },
                {
                    path: "/worksList",
                    name: "worksList",
                    component: worksList,
                    meta: [
                        {title: '博雅作品', link: "", type: true},
                        {title: '作品列表', link: "/worksList", type: true}
                    ],
                },
                {
                    path: "/worksUp/:id?",
                    name: "worksUp",
                    component: worksUp,
                    meta: [
                        {title: '博雅作品', link: "", type: true},
                        {title: '作品上传', link: "/worksUp", type: true}
                    ],
                },
                {
                    path: "/dutyList",
                    name: "dutyList",
                    component: dutyList,
                    meta: [
                        {title: '责任与信任', link: "", type: true},
                        {title: '图片列表', link: "/dutyList", type: true}
                    ],
                },
                {
                    path: "/dutyUp/:id?",
                    name: "dutyUp",
                    component: dutyUp,
                    meta: [
                        {title: '责任与信任', link: "", type: true},
                        {title: '上传', link: "/dutyUp", type: true}
                    ],
                },
                {
                    path: "/jobsList",
                    name: "jobsList",
                    component: jobsList,
                    meta: [
                        {title: '加入我们', link: "", type: true},
                        {title: '职位列表', link: "/jobsList", type: true}
                    ],
                },
                {
                    path: "/jobsUp/:id?",
                    name: "jobsUp",
                    component: jobsUp,
                    meta: [
                        {title: '加入我们', link: "", type: true},
                        {title: '职位上传', link: "/jobsUp", type: true}
                    ],
                },
                {
                    path: "/structure",
                    name: "structure",
                    component: structure,
                    meta: [
                        {title: '集团简介', link: "", type: true},
                        {title: '集团架构', link: "/structure", type: true}
                    ],
                },
                {
                    path: "/structureUp/:id?",
                    name: "structureUp",
                    component: structureUp,
                    meta: [
                        {title: '集团简介', link: "", type: true},
                        {title: '集团架构', link: "/structure", type: true},
                        {title: '上传', link: "/structureUp", type: true}
                    ],
                },
                {
                    path: "/construction",
                    name: "construction",
                    component: construction,
                    meta: [
                        {title: '集团简介', link: "", type: true},
                        {title: '党建中心', link: "/construction", type: true}
                    ],
                },
                {
                    path: "/construction/up/:id?",
                    name: "constructionUp",
                    component: constructionUp,
                    meta: [
                        {title: '集团简介', link: "", type: true},
                        {title: '党建中心', link: "/construction", type: true},
                        {title: '上传', link: "/construction/up/:id?", type: true}
                    ],
                },
                {
                    path: "/management",
                    name: "management",
                    component: management,
                    meta: [
                        {title: '集团简介', link: "", type: true},
                        {title: '管理团队', link: "/management", type: true}
                    ],
                },
                {
                    path: "/managementUp/:id?",
                    name: "managementUp",
                    component: managementUp,
                    meta: [
                        {title: '集团简介', link: "", type: true},
                        {title: '管理团队', link: "/management", type: true},
                        {title: '上传', link: "/managementUp", type: true}
                    ],
                },
                {
                    path: "/creative",
                    name: "creative",
                    component: creative,
                    meta: [
                        {title: '创意中心', link: "", type: true},
                        {title: '作品列表', link: "/creative", type: true}
                    ],
                },
                {
                    path: "/creativeUp/:id?",
                    name: "creativeUp",
                    component: creativeUp,
                    meta: [
                        {title: '创意中心', link: "", type: true},
                        {title: '上传', link: "/creativeUp", type: true}
                    ],
                },
                {
                    path: "/exhibit",
                    name: "exhibit",
                    component: exhibit,
                    meta: [
                        {title: '展览展示', link: "", type: true},
                        {title: '作品列表', link: "/exhibit", type: true}
                    ],
                },
                {
                    path: "/exhibitUp/:id?",
                    name: "exhibitUp",
                    component: exhibitUp,
                    meta: [
                        {title: '展览展示', link: "", type: true},
                        {title: '上传', link: "/exhibitUp", type: true}
                    ],
                },
                {
                    path: "/roleList",
                    name: "roleList",
                    component: roleList,
                    meta: [
                        {title: '系统设置', link: "", type: true},
                        {title: '角色管理', link: "/roleList", type: true}
                    ],
                },


            ]
        },

]
const router = new VueRouter({
    routes: routes
});
router.beforeEach((to, from, next) => {
    next()
});
export default router;
